import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { TariffsModuleService } from '../proxy/controlling/controllers/tariffs-module.service';

FieldBuilder.setNamespace('Controlling');

export const GROUPINGTYPEOFVARIABLE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.GroupingTypeOfVariable.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.GroupingTypeOfVariable.Code')
    .required()
    .minLength(2)
    .maxLength(25)
    .build(),
  FieldBuilder
    .foreignKey('tariffsModuleId', 'Entity.TariffsModule', TariffsModuleService)
    .required()
    .displayFromNested('tariffsModule.name')
    .sortBy('tariffsModule.name')
    .build(),
];

export const GROUPINGTYPEOFVARIABLE_CONFIG = {
  entityName: 'GroupingTypeOfVariable',
  localizationKey: 'Controlling::Entity.GroupingTypeOfVariable',
  fields: GROUPINGTYPEOFVARIABLE_FIELDS,
  permission: 'ControllingLiquidations.GroupingTypeOfVariables',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
